<!-- 帮助文档 -->
<template>
  <div class="help-document">
    <gat-head></gat-head>
    <div class="help-center clearfix">
      <!-- 左侧导航菜单 -->
      <div class="help-left">
        <h2 class="title">AI-T编辑器（积木模式）</h2>
        <ul>
          <li
            v-for="item in blocksTypes"
            :key="item.name"
            :class="['item', navState === item.type ? 'active' : '']"
            @click="navClick(item.type)"
          >
            <span>{{ item.name }}</span>
          </li>
          <hr />
          <el-tree
            v-if="filterToolList.length"
            :data="filterToolList"
            :props="defaultProps"
            node-key="blocksId"
            :default-expanded-keys="[blocksId]"
            :default-checked-keys="[blocksId]"
            accordion
            :highlight-current="true"
            @node-click="handleNodeClick"
            ref="toolTree"
          >
          </el-tree>
        </ul>
      </div>
      <!-- 右侧主内容 -->
      <ai-introduce-page v-if="navState === 'AiIntroduce'"></ai-introduce-page>
      <!-- <kee-alive> -->
      <help-document-page
        v-show="navState !== 'AiIntroduce'"
        :currentHelp="currentHelp"
        :hashId="hashId"
      ></help-document-page>
      <!-- </kee-alive> -->
    </div>
  </div>
</template>

<script>
import PYTHON from '@/axios/personalSpace/AiEditor/blocks.js'
import AiIntroducePage from './AiIntroducePage.vue'
import HelpDocumentPage from '../HelpDocumentPage.vue'
import HelpData from './AiTEditorHelp.js'

// import GatFooter from '@/components/common/GatFooter.vue'
import Blockly from '@/assets/blockly/renderers/index.js'
import { mapGetters } from 'vuex'
export default {
  name: 'help-document',
  components: {
    AiIntroducePage,
    HelpDocumentPage,
    // NavMenu,
    // GatFooter,
  },

  data() {
    return {
      currentHelp: [],
      scrollTop: 0,
      navState: 'AiIntroduce',
      navStateName: '',
      hashId: 'Events',
      blocksTypes: [
        { name: '简介', type: 'AiIntroduce' },
        { name: '事件 (Events)', type: 'Events' },
        { name: '控制 (Control)', type: 'Control' },
        { name: '运算 (Operators)', type: 'Operators' },
        { name: '字符串 (Text)', type: 'Text' },
        { name: '列表 (List)', type: 'List' },
        { name: '字典 (Dictionary)', type: 'Dictionary' },
        { name: '变量 (Variable)', type: 'Variable' },
        { name: '函数 (Function)', type: 'Function' },
        { name: '媒体 (Media)', type: 'Media' },
        // { name: '海龟库 (Turtle)', type: 'Turtle' },
      ],
      // blockList: [],
      toolList: [], // 接口返回模型列表
      filterToolList: [], // 过滤返回模型列表
      blocksId: '',
      defaultProps: {
        children: 'children',
        label: 'blocksName',
      },
    }
  },
  watch: {
    currentHelp: {
      handler(val) {
        // console.log('val ', val)
      },
      // deep: true,
      // immediate: true,
    },
  },
  computed: {
    ...mapGetters(['trainingBlockList']),
  },
  async mounted() {
    await this.getBlockList()
    let navStateName = window.location.search.split('=')[1] || 'AiIntroduce'
    this.navStateName = navStateName
    this.blocksId = navStateName.replace(/-/g, '')
    if (this.blocksId) {
      // if(this.blocksId &&this.blocksId !="AiIntroduce"){
      console.log('this.blocksId', this.blocksId)
      // this.currentHelp = null
      this.currentHelp = HelpData.Inits
      this.navClick(this.blocksId)
    }
  },
  // mounted() {},
  methods: {
    onHashId(val) {
      this.hashId = val
    },
    onNavState(val) {
      this.navClick(val)
    },
    navClick(val) {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      this.navState = val
      // console.log('this.navStateName',this.navStateName)
      if (this.navStateName !== 'AiIntroduce') {
        // if (val === this.navStateName) {
        this.hashId = window.location.hash.split('#')[1]
        console.log('this.hashId--2', this.hashId)
      }

      switch (true) {
        case val === 'Events':
          // if(this.currentHelp&&this.currentHelp[0].id !=HelpData.Events[0].id){
          //   }
          this.currentHelp = HelpData.Events
          break
        case val === 'Control':
          this.currentHelp = HelpData.Control
          break
        case val === 'Operators':
          this.currentHelp = HelpData.Operators
          break
        case val === 'Text':
          this.currentHelp = HelpData.Text
          break
        case val === 'List':
          this.currentHelp = HelpData.List
          break
        case val === 'Dictionary':
          this.currentHelp = HelpData.Dictionary
          break
        case val === 'Variable':
          this.currentHelp = HelpData.Variable
          break
        case val === 'Function':
          this.currentHelp = HelpData.Function
          break
        case val === 'Media':
          this.currentHelp = HelpData.Media
          break
        case val === 'AiIntroduce':
          //  this.currentHelp =null
          break
        default:
          setTimeout(() => {
            console.log('---val', val)
            if (val) {
              this.handleNodeClick(val)
            }
          }, 1000)
          break
      }
    },

    creatBlock(arr) {
      const newArr = arr.filter((item) =>
        /^[\u4e00-\u9fa5a-zA-Z]*$/.test(item.blocksName)
      )
      newArr.map((item) => {
        if (item.children && item.children !== 0 && item.children[0] !== null) {
          item.children = this.creatBlock(item.children)
        }
        return item
      })
      return newArr
    },

    handleNodeClick(data) {
      let blocksId,
        dataList = []
      if (typeof data == 'object') {
        blocksId = data.blocksId
      } else {
        blocksId = data
      }

      creatBlock(this.toolList, blocksId)

      function creatBlock(toolList, id, blocksLabelTitle) {
        toolList.forEach((item) => {
          if (
            item.children &&
            item.children.length !== 0 &&
            item.children[0] !== null
          ) {
            creatBlock(item.children, id, item.blocksName)
          } else {
            if (item.parentId === id) {
              dataList.push({
                rightnavs: blocksLabelTitle || item.blocksLabel,
                id: item.blocksName,
                title: item.blocksLabel || item.blocksName,
                content: item.blocksDescribe,
                blocksCase: item.blocksCase,
                blockText: `<block type="${item.blocksName}"></block>`,
              })
            }
          }
        })
      }
      // console.log('dataList',dataList)
      if (dataList && dataList.length) {
        this.navState = blocksId
      }
      this.toolList.forEach(item => {
        if (item.children.length === 0  &&  item.blocksId === blocksId) {
          this.navState = blocksId
          if (item.blocksName === '公共模型') {
            dataList.push({
              // rightnavs: item.blocksName,
              id: item.blocksName,
              title: '公共模型',
              content: '公共模型：公共模型是由系统超级管理员内置的模型，只有超级管理员公开发布后，老师/学生才可查看使用。',
              blockText: ''
            })
          }
          if (item.blocksName === '我的模型') {
            dataList.push({
              // rightnavs: item.blocksName,
              id: item.blocksName,
              title: '我的模型',
              content: '我的模型：“我的模型”是当前用户训练并发布的模型，可根据项目需要自由查看调用。',
              blockText: ''
            })
          }
          if (item.blocksName === '新建积木') {
            dataList.push({
              // rightnavs: item.blocksName,
              id: item.blocksName,
              title: '新建积木',
              content: '新建积木：当上述的模块没有合适的“积木”可以用的时候，可以通过“新建积木”来设定一个自己想要的积木。',
              blockText: ''
            })
          }
        }
      });

      this.currentHelp = dataList
    },

    // 过滤掉积木块节点
    convert(arr) {
      const newArr = arr.filter((item) =>
        /^[\u4e00-\u9fa5a-zA-Z]*$/.test(item.blocksName)
      )
      newArr.map((item) => {
        if (
          item.children &&
          item.children.length != 0 &&
          item.children[0] !== null
        ) {
          item.children = this.convert(item.children)
        }
        return item
      })
      return newArr
    },
    async getBlockList() {
      let self = this,
        blockList = []

      if (this.trainingBlockList && this.trainingBlockList.length) {
        blockList = self.blockListHandler(this.trainingBlockList)
        await self.defineBlockJs(blockList)
        self.toolList = this.treeHandler(blockList) // 处理成树形数据结构

        let toolList = JSON.parse(JSON.stringify(this.toolList))
        self.filterToolList = this.convert(toolList) // 过滤掉积木块节点
      } else {
        PYTHON.getBlockList()
          .then((res) => {
            if (res && res.isSuccess) {
              blockList = res.data
              blockList = self.blockListHandler(blockList)
              self.defineBlockJs(blockList)
              self.toolList = this.treeHandler(blockList) // 处理成树形数据结构
              let toolList = JSON.parse(JSON.stringify(this.toolList))
              self.filterToolList = this.convert(toolList) // 过滤掉积木块节点
            } else {
              self.toolList = []
            }
          })
          .catch((err) => console.log(err))
      }
    },
    // 处理成树形数据结构
    treeHandler(list) {
      let listSort = list.sort((prev, next) => {
        if (prev.blocksLevel - next.blocksLevel != 0) {
          return prev.blocksLevel - next.blocksLevel
        } else {
          return prev.blocksOrder - next.blocksOrder
        }
      })
      //  构造树
      let arr = []
      listSort.forEach((item) => {
        if (item.blocksCase) {
          // console.log('item',item)
        }
        item.children = []
        if (item.parentId == '00000000000000000000000000000000') {
          // if (item.parentId == '00000000-0000-0000-0000-000000000000') {
          arr.push(item)
        } else {
          iterated(arr)
          //迭代器
          /* eslint-disable */

          function iterated(arr) {
            if (!arr || !arr.length) return //跳出迭代
            arr.forEach((item2) => {
              if (item.parentId == item2.blocksId) {
                if (item2.blocksCase) {
                  // console.log('item2',item2)
                }
                return item2.children.push(item) //跳出循环
              } else {
                iterated(item2.children) //迭代
              }
            })
          }
        }
      })
      return arr
    },
    defineBlockJs(list) {
      let reg_label = /<label/
      console.log('list.length', list.length)
      list.forEach((blockObj) => {
        if (
          blockObj &&
          blockObj.blocksContent &&
          blockObj.showType != 1 &&
          !reg_label.test(blockObj.blocksContent)
        ) {
          let blockJs = new Function('Blockly', blockObj['blocksContent'])

          if (Blockly) {
            // blockJs(Blockly)
            // console.log('Blockly',Blockly)
            //须异步，不然容器出错
            setTimeout(() => {
              blockJs.call(this, Blockly)
            }, 10)
          }
        }
      })
    },
    blockListHandler(trainingBlockList) {
      let list = [...trainingBlockList]
      list.forEach((item) => {
        item.blocksId = item.blocksId.replace(/-/g, '')
        item.parentId = item.parentId.replace(/-/g, '')
      })
      return list
    },
  }, //methods end
}
</script>

<style lang="scss" scoped>
.help {
  &-document {
    background: #f2f5fc;
  }
  &-center {
    width: 1200px;
    margin: 0 auto;
    padding-top: 120px;
    box-sizing: border-box;
  }
  &-left {
    position: fixed;
    // width: 20%;
    min-width: 220px;
    // height: 100%;
    margin-right: 10px;
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.05);
    height: 85%;
    overflow-x: hidden;
    overflow-y: auto;

    .title {
      line-height: 60px;
      font-size: 16px;
      color: #333;
      text-align: center;
    }
    .item {
      border-left: 3px solid transparent;
      text-indent: 17px;
      font-size: 14px;
      color: #333;
      line-height: 40px;
      cursor: pointer;
      // &:hover,
      &.active {
        color: #4c88ff;
        border-left: 3px solid #4c88ff;
        background: #dfeaff;
      }
      &:hover {
        color: #4c88ff;
        background: #f0f4ff;
      }
      a {
        font-size: 14px;
        color: #333;
      }
    }
  }
}
.help-document .gat-head {
  width: 100%;
  position: fixed !important;
  top: 0;
  z-index: 3;
  box-sizing: border-box;
}

.help-document {
  ::v-deep .el-tree-node__content {
    height: 40px;
    border-left: 3px solid transparent;
    text-indent: 17px;
    font-size: 14px;
    color: #333;
    line-height: 40px;
    cursor: pointer;
    &:hover,
    &.active {
      // border-left: 3px solid #4c88ff;
      // background: #dfeaff;
      background: #f0f4ff;
      color: #4c88ff;
    }
  }
  ::v-deep .el-tree-node.is-current > .el-tree-node__content {
    // background: #f0f4ff;
    background: #dfeaff;
    border-left: 3px solid #4c88ff;
    color: #4c88ff;
    font-weight: bold;
  }
  ::v-deep .el-tree-node__content > .el-tree-node__expand-icon {
    width: 10px;
    height: 10px;
  }
  ::v-deep.el-tree-node__content {
    text-indent: 0;
  }
}

.clearfix:after {
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
  content: '';
}
</style>
